import { Box, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { PimDashboardState } from "context/PimDashboardContext";
import { sizeTypeCol } from "data/pimData";

export const generateSizeCol = (sizeTypeMasterData, selectedSizeType) => {
	const sizeTypeData = sizeTypeMasterData?.filter((size) => size.size_type === selectedSizeType) || [];
	const sizeColData = {};

	sizeTypeData.forEach((size) => {
		Object.keys(size).forEach((sizeCol) => {
			if (sizeTypeCol.includes(sizeCol) && size[sizeCol] !== null) {
				sizeColData[sizeCol] = {
					key: sizeCol,
					name: size[sizeCol],
				};
			}
		});
	});

	return sizeColData;
};

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const CommonDataGrid = ({ size_type, rows }) => {
	const { sizeTypeMasterData } = PimDashboardState();
	const sizeTypes = generateSizeCol(sizeTypeMasterData, size_type);

	const sizeTableColumns = [
		{
			field: "style_name",
			headerName: "Style",
			width: 110,
			...colStyle,
		},
		{
			field: "category",
			headerName: "Category",
			width: 110,
			...colStyle,
		},
		{
			field: "color",
			headerName: "Color",
			width: 110,
			...colStyle,
		},
		{
			field: "pallete",
			headerName: "Pallete",
			width: 120,
			...colStyle,
		},
		...Object.keys(sizeTypes).map((row) => {
			const obj = sizeTypes[row];
			return {
				field: obj.key,
				headerName: obj.name,
				width: 100,
				type: "number",
				...colStyle,
				renderCell: ({ row }) => (
					<Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
						<Typography variant="subtitle2">{row[obj.key]}</Typography>
					</Stack>
				),
			};
		}),
		{
			field: "total_qty",
			headerName: "Total Qty",
			width: 90,
			type: "number",
			...colStyle,
		},
	];

	return (
		<Box sx={{ padding: "10px 0" }}>
			<DataGrid
				rows={rows || []}
				columns={sizeTableColumns}
				getRowId={(row) => row.id}
				sx={{
					minHeight: 120,
					maxHeight: 320,
					border: "none",
					"& .MuiDataGrid-row": {
						border: "none",
					},
					"& .MuiDataGrid-columnHeader": {
						cursor: "pointer",
					},
					"& .MuiDataGrid-columnHeaders": {
						background: grey[300],
						border: "none",
						borderRadius: 1,
					},
				}}
				columnHeaderHeight={35}
				rowHeight={40}
				disableRowSelectionOnClick
				pageSizeOptions={[100]}
				hideFooter
			/>
		</Box>
	);
};

export default CommonDataGrid;
